import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { isEmptyOrNil } from 'libs/empty'

const CustomsTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.primary[300],
    fontSize: '12px',
  },
  arrow: {
    color: theme.palette.primary[300],
  },
}))(Tooltip)

const LimitTooltip = ({ title, maxWidth = 150, children, ...props }) => {
  const textRef = useRef(null)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    const el = textRef.current
    if (!el || isEmptyOrNil(title)) return

    const isOverflowing = el.scrollWidth > el.clientWidth
    setShowTooltip(isOverflowing)
  }, [title, children])

  const content = (
    <span
      ref={textRef}
      style={{
        display: 'inline-block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth,
        verticalAlign: 'bottom',
      }}
    >
      {title}
    </span>
  )

  if (!title || isEmptyOrNil(title)) return null

  return showTooltip ? (
    <CustomsTooltip title={title} arrow {...props}>
      {content}
    </CustomsTooltip>
  ) : (
    content
  )
}

LimitTooltip.propTypes = {
  title: PropTypes.string,
  maxWidth: PropTypes.number,
  children: PropTypes.node,
}

export default LimitTooltip
